<template>
  <div class="task-wrap">
    <div class="task-content">
      <div class="page-header">任务中心</div>
      <div class="header-filter">
        <el-select
          collapse-tags
          class="all-select select-item"
          popper-class="BI-select BI-select-product report_select"
          multiple
          v-model="filterTable.platList"
          placeholder="全部渠道"
        >
          <el-option
            v-for="item in platTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          collapse-tags
          class="all-select select-item"
          popper-class="BI-select BI-select-product report_select"
          multiple
          placeholder="全部产品"
          v-model="filterTable.pkgList"
          filterable
        >
          <el-option
            v-for="item of appList"
            :key="item.package_name"
            :label="item.app_name + '（' + item.package_name + '）'"
            :value="item.package_name"
          >
          </el-option>
        </el-select>
        <el-select
          collapse-tags
          class="all-select select-item"
          popper-class="BI-select BI-select-product report_select"
          multiple
          filterable
          v-model="filterTable.advertiserList"
          placeholder="全部投放账户"
        >
          <el-option
            v-for="item of advertiserIdList"
            :key="item.advertiserId"
            :label="item.advertiserName"
            :value="item.advertiserId"
          >
          </el-option>
        </el-select>
        <el-select
          collapse-tags
          class="all-select select-item"
          popper-class="BI-select BI-select-product report_select"
          multiple
          filterable
          v-model="filterTable.creatorList"
          placeholder="全部优化师"
        >
          <el-option
            v-for="item of optimizerList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select class="select-item" v-model="filterTable.status" placeholder="全部状态">
          <el-option label="全部状态" :value="null"> </el-option>
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input class="select-item" v-model="filterTable.taskId" placeholder="请输入任务Id">
        </el-input>
        <el-date-picker
          v-model="filterTable.formdate"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          style="width: 270px"
        ></el-date-picker>
        <el-button class="add-btn" @click="handleReset">重置</el-button>
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>
      <div class="table-wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="platType" label="渠道" width="150px">
            <template slot-scope="scope">
              {{ platTypeList.find((item) => item.value === scope.row.platType).label }}
            </template>
          </el-table-column>
          <el-table-column prop="templateId" width="280px" label="任务ID"> </el-table-column>
          <el-table-column prop="advertiserId" label="账户" width="350px">
            <template slot-scope="scope">
              {{ scope.row.advertiserName }}({{ scope.row.advertiserId }})
            </template>
          </el-table-column>
          <el-table-column prop="appName" label="产品"> </el-table-column>
          <el-table-column prop="createTime" label="提交时间"> </el-table-column>
          <el-table-column prop="creator" label="优化师"> </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status !== 2">
                {{ (statusList.find((item) => item.value === scope.row.status) || {}).label }}</span
              >
              <el-link v-else type="danger" @click="viewFailReason(scope.row)" :underline="false"
                >失败 <i class="el-icon-question" style="margin-left: 2px"></i
              ></el-link>
            </template>
          </el-table-column>
        </el-table>
        <self-pagination
          class="table-pagination"
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
    <!-- 新增配置弹框 -->
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-table :data="reasonData" v-if="failType === 5">
        <el-table-column prop="campaignName" label="广告系列名称"> </el-table-column>
        <el-table-column prop="adSetName" label="广告组名称"> </el-table-column>
        <el-table-column prop="failDetailMsg" label="失败原因"> </el-table-column>
      </el-table>
      <el-table :data="reasonData" v-else>
        <el-table-column prop="campaignName" :label="failType === 4 ? '项目名称' : '广告组名称'">
        </el-table-column>
        <el-table-column prop="adSetName" :label="failType === 4 ? '广告名称' : '广告计划名称'">
        </el-table-column>
        <el-table-column prop="failDetailMsg" label="失败原因"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getTaskList, getFailTaskDetail } from "@/api/tools.js";
import { getCommonProductList, getUserInfoList, getAllAdvertiserInfo } from "@/api/api.js";
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
import { platTypeList } from "@/config/enum";
import moment from "moment";

const statusList = [
  { label: "已完成", value: 1 },
  { label: "执行中", value: 0 },
  { label: "失败", value: 2 },
];

export default {
  name: "TrackManage",
  data() {
    return {
      platTypeList,
      statusList,
      filterTable: {
        platList: [],
        pkgList: [],
        advertiserList: [],
        creatorList: [],
        status: null,
        taskId: "",
        formdate: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), new Date()],
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      dialogVisible: false,
      tableData: [],
      reasonData: [],
      failType: 1,
      appList: [],
      advertiserIdList: [],
      optimizerList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
      },
    };
  },
  mounted() {
    this.ininSelect();
    this.selectTable();
  },
  methods: {
    ininSelect() {
      //产品
      getCommonProductList().then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
      getAllAdvertiserInfo().then((res) => {
        if (res.code === "0000") {
          this.advertiserIdList = res.advertiseInfos;
        }
      });
      getUserInfoList({
        orgIds: "254,255",
      }).then((res) => {
        if (res.code === "0000") {
          this.optimizerList = res.data;
        }
      });
    },
    selectTable() {
      const { platList, pkgList, advertiserList, creatorList, status, taskId, formdate } =
        this.filterTable;
      getTaskList({
        page: this.pageData.page,
        pageSize: this.pageData.size,
        platList,
        pkgList,
        advertiserList,
        creatorList,
        status,
        taskId,
        beginDate: moment(formdate[0]).format("yyyy-MM-DD") + " 00:00:00",
        endDate: moment(formdate[1]).format("yyyy-MM-DD") + " 23:59:59",
      }).then((res) => {
        if (res.code === "0000") {
          this.tableData = res.data.list;
          this.pageData.total = res.data.total;
        }
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.selectTable();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.selectTable();
    },
    handleSearch() {
      this.pageData.page = 1;
      this.selectTable();
    },
    handleReset() {
      this.filterTable = {
        platList: [],
        pkgList: [],
        advertiserList: [],
        creatorList: [],
        status: null,
        taskId: "",
        formdate: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), new Date()],
      };
      this.handleSearch();
    },
    viewFailReason(data) {
      this.dialogVisible = true;
      this.failType = data.platType;
      getFailTaskDetail({
        taskId: data.templateId,
      }).then((res) => {
        this.reasonData = res.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.task-wrap {
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  .task-content {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    height: 100%;
    padding: 16px 24px;
    box-sizing: border-box;
    overflow: auto;
    .page-header {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 15px;
    }
    .header-filter {
      display: flex;
      align-items: center;
      margin-top: 16px;
      .select-item {
        width: 200px;
        margin-right: 24px;
      }
      .add-btn {
        margin-left: 20px;
      }
    }
    .table-wrap {
      margin-top: 16px;
      .link-wrap {
        display: flex;
        align-items: center;
        .link {
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .table-pagination {
        padding-right: 0px;
        /deep/.el-pagination {
          padding-right: 0px;
        }
      }
    }
  }
  /deep/ .el-dialog__body {
    padding-bottom: 16px;
  }
}
</style>
